<template>
    <div class="service-visual">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <div class="service-visual__inner" style="background-image: url(/images/test-img.png)"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper/bundle";

export default {
    props: {
    },
    data: () => ({
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.swiper = new Swiper(`.service-visual .swiper-container`, {
                    effect: 'fade',
                    allowTouchMove: true,
                    centeredSlides: true,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    speed: 500,
                    loop: true,
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
// main-visual
.service-visual {
    width: 100%;
}
.service-visual__inner {
    position: relative;
    width: 100%;
    height: calc(100vh - var(--header-body));
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
